/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions, IQService} from 'angular';
import TSBenutzer from '../../../../models/TSBenutzer';
import BenutzerRS from '../../../service/BenutzerRS.rest';
import ILogService = angular.ILogService;
import IPromise = angular.IPromise;

declare let require: any;
declare let angular: any;
require('./dv-benutzer-typeahead.scss');

export class DVBenutzerTypeaheadComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        selectedBenutzer: '=',
        inputName: '@?',
        inputPlaceholder: '@?',
        inputDisabled: '<?',
        label: '@',
        clazz: '@',
        ngRequired: '<',
    };
    template = require('./dv-benutzer-typeahead.html');
    controller = DvBenutzerTypeaheadController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvBenutzerTypeaheadController {

    inputDisabled: boolean;
    selectedBenutzer: TSBenutzer;
    ngRequired: boolean;
    valueRequired: boolean = true; // default required

    static $inject = ['$log', '$q', 'BenutzerRS'];

    constructor(private $log: ILogService, private $q: IQService, private benutzerRS: BenutzerRS) {
    }

    $onInit() {
        if (this.ngRequired !== undefined) {
            this.valueRequired = this.ngRequired;
        }
        if (this.inputDisabled === undefined) {
            this.inputDisabled = false;
        }

    }

    private loadSuggestElements(searchString: string): IPromise<Array<TSBenutzer>> {
        return this.benutzerRS.readBenutzerSuggestion(searchString).then((response) => {
            return response;

        })
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-typeahead/dv-benutzer-typeahead/dv-benutzer-typeahead.ts